/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ConsentRouteImport } from './routes/consent'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AdvisorRouteImport } from './routes/_advisor'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as AppSignupRouteImport } from './routes/_app/signup'
import { Route as AppPendingApprovalRouteImport } from './routes/_app/pending-approval'
import { Route as AppLoginRouteImport } from './routes/_app/login'
import { Route as AppFormRouteImport } from './routes/_app/form'
import { Route as AppForgotPasswordRouteImport } from './routes/_app/forgot-password'
import { Route as ProtectedDashboardIndexRouteImport } from './routes/_protected/dashboard.index'
import { Route as ProtectedDashboardSettingsRouteImport } from './routes/_protected/dashboard.settings'
import { Route as ProtectedDashboardReportsRouteImport } from './routes/_protected/dashboard.reports'
import { Route as ProtectedDashboardRenewalsRouteImport } from './routes/_protected/dashboard.renewals'
import { Route as ProtectedDashboardPipelineRouteImport } from './routes/_protected/dashboard.pipeline'
import { Route as ProtectedDashboardNotificationsRouteImport } from './routes/_protected/dashboard.notifications'
import { Route as ProtectedDashboardFormsRouteImport } from './routes/_protected/dashboard.forms'
import { Route as ProtectedDashboardClientsRouteImport } from './routes/_protected/dashboard.clients'
import { Route as ChatChatTypeRouteImport } from './routes/_chat/chat.$type'
import { Route as AppResetPasswordTokenRouteImport } from './routes/_app/reset-password.$token'
import { Route as AppConfirmEmailChangeTokenRouteImport } from './routes/_app/confirm-email-change.$token'
import { Route as AppApproveTokenRouteImport } from './routes/_app/approve.$token'
import { Route as ProtectedDashboardFormsIndexRouteImport } from './routes/_protected/dashboard.forms.index'
import { Route as AdvisorAUsernameIndexRouteImport } from './routes/_advisor/a.$username.index'
import { Route as AdvisorAUsernameTypeRouteImport } from './routes/_advisor/a.$username.$type'
import { Route as ProtectedDashboardFormsTypeIdRouteImport } from './routes/_protected/dashboard.forms.$type.$id'
import { Route as ProtectedDashboardFormsTypeIdIndexRouteImport } from './routes/_protected/dashboard.forms.$type.$id.index'
import { Route as ProtectedDashboardFormsTypeIdEditRouteImport } from './routes/_protected/dashboard.forms.$type.$id.edit'

const ConsentRoute = ConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdvisorRoute = AdvisorRouteImport.update({
  id: '/_advisor',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const AppSignupRoute = AppSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/signup.lazy').then((d) => d.Route))
const AppPendingApprovalRoute = AppPendingApprovalRouteImport.update({
  id: '/pending-approval',
  path: '/pending-approval',
  getParentRoute: () => AppRoute,
} as any)
const AppLoginRoute = AppLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/login.lazy').then((d) => d.Route))
const AppFormRoute = AppFormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => AppRoute,
} as any)
const AppForgotPasswordRoute = AppForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AppRoute,
} as any)
const ProtectedDashboardIndexRoute = ProtectedDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedDashboardRoute,
} as any).lazy(() =>
  import('./routes/_protected/dashboard.index.lazy').then((d) => d.Route),
)
const ProtectedDashboardSettingsRoute =
  ProtectedDashboardSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dashboard.settings.lazy').then((d) => d.Route),
  )
const ProtectedDashboardReportsRoute =
  ProtectedDashboardReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dashboard.reports.lazy').then((d) => d.Route),
  )
const ProtectedDashboardRenewalsRoute =
  ProtectedDashboardRenewalsRouteImport.update({
    id: '/renewals',
    path: '/renewals',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dashboard.renewals.lazy').then((d) => d.Route),
  )
const ProtectedDashboardPipelineRoute =
  ProtectedDashboardPipelineRouteImport.update({
    id: '/pipeline',
    path: '/pipeline',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dashboard.pipeline.lazy').then((d) => d.Route),
  )
const ProtectedDashboardNotificationsRoute =
  ProtectedDashboardNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dashboard.notifications.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedDashboardFormsRoute = ProtectedDashboardFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => ProtectedDashboardRoute,
} as any)
const ProtectedDashboardClientsRoute =
  ProtectedDashboardClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => ProtectedDashboardRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dashboard.clients.lazy').then((d) => d.Route),
  )
const ChatChatTypeRoute = ChatChatTypeRouteImport.update({
  id: '/chat/$type',
  path: '/chat/$type',
  getParentRoute: () => ChatRoute,
} as any).lazy(() =>
  import('./routes/_chat/chat.$type.lazy').then((d) => d.Route),
)
const AppResetPasswordTokenRoute = AppResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => AppRoute,
} as any)
const AppConfirmEmailChangeTokenRoute =
  AppConfirmEmailChangeTokenRouteImport.update({
    id: '/confirm-email-change/$token',
    path: '/confirm-email-change/$token',
    getParentRoute: () => AppRoute,
  } as any)
const AppApproveTokenRoute = AppApproveTokenRouteImport.update({
  id: '/approve/$token',
  path: '/approve/$token',
  getParentRoute: () => AppRoute,
} as any)
const ProtectedDashboardFormsIndexRoute =
  ProtectedDashboardFormsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedDashboardFormsRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dashboard.forms.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AdvisorAUsernameIndexRoute = AdvisorAUsernameIndexRouteImport.update({
  id: '/a/$username/',
  path: '/a/$username/',
  getParentRoute: () => AdvisorRoute,
} as any)
const AdvisorAUsernameTypeRoute = AdvisorAUsernameTypeRouteImport.update({
  id: '/a/$username/$type',
  path: '/a/$username/$type',
  getParentRoute: () => AdvisorRoute,
} as any)
const ProtectedDashboardFormsTypeIdRoute =
  ProtectedDashboardFormsTypeIdRouteImport.update({
    id: '/$type/$id',
    path: '/$type/$id',
    getParentRoute: () => ProtectedDashboardFormsRoute,
  } as any)
const ProtectedDashboardFormsTypeIdIndexRoute =
  ProtectedDashboardFormsTypeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedDashboardFormsTypeIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dashboard.forms.$type.$id.index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedDashboardFormsTypeIdEditRoute =
  ProtectedDashboardFormsTypeIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => ProtectedDashboardFormsTypeIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dashboard.forms.$type.$id.edit.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/consent': typeof ConsentRoute
  '/forgot-password': typeof AppForgotPasswordRoute
  '/form': typeof AppFormRoute
  '/login': typeof AppLoginRoute
  '/pending-approval': typeof AppPendingApprovalRoute
  '/signup': typeof AppSignupRoute
  '/dashboard': typeof ProtectedDashboardRouteWithChildren
  '/approve/$token': typeof AppApproveTokenRoute
  '/confirm-email-change/$token': typeof AppConfirmEmailChangeTokenRoute
  '/reset-password/$token': typeof AppResetPasswordTokenRoute
  '/chat/$type': typeof ChatChatTypeRoute
  '/dashboard/clients': typeof ProtectedDashboardClientsRoute
  '/dashboard/forms': typeof ProtectedDashboardFormsRouteWithChildren
  '/dashboard/notifications': typeof ProtectedDashboardNotificationsRoute
  '/dashboard/pipeline': typeof ProtectedDashboardPipelineRoute
  '/dashboard/renewals': typeof ProtectedDashboardRenewalsRoute
  '/dashboard/reports': typeof ProtectedDashboardReportsRoute
  '/dashboard/settings': typeof ProtectedDashboardSettingsRoute
  '/dashboard/': typeof ProtectedDashboardIndexRoute
  '/a/$username/$type': typeof AdvisorAUsernameTypeRoute
  '/a/$username/': typeof AdvisorAUsernameIndexRoute
  '/dashboard/forms/': typeof ProtectedDashboardFormsIndexRoute
  '/dashboard/forms/$type/$id': typeof ProtectedDashboardFormsTypeIdRouteWithChildren
  '/dashboard/forms/$type/$id/edit': typeof ProtectedDashboardFormsTypeIdEditRoute
  '/dashboard/forms/$type/$id/': typeof ProtectedDashboardFormsTypeIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/consent': typeof ConsentRoute
  '/forgot-password': typeof AppForgotPasswordRoute
  '/form': typeof AppFormRoute
  '/login': typeof AppLoginRoute
  '/pending-approval': typeof AppPendingApprovalRoute
  '/signup': typeof AppSignupRoute
  '/approve/$token': typeof AppApproveTokenRoute
  '/confirm-email-change/$token': typeof AppConfirmEmailChangeTokenRoute
  '/reset-password/$token': typeof AppResetPasswordTokenRoute
  '/chat/$type': typeof ChatChatTypeRoute
  '/dashboard/clients': typeof ProtectedDashboardClientsRoute
  '/dashboard/notifications': typeof ProtectedDashboardNotificationsRoute
  '/dashboard/pipeline': typeof ProtectedDashboardPipelineRoute
  '/dashboard/renewals': typeof ProtectedDashboardRenewalsRoute
  '/dashboard/reports': typeof ProtectedDashboardReportsRoute
  '/dashboard/settings': typeof ProtectedDashboardSettingsRoute
  '/dashboard': typeof ProtectedDashboardIndexRoute
  '/a/$username/$type': typeof AdvisorAUsernameTypeRoute
  '/a/$username': typeof AdvisorAUsernameIndexRoute
  '/dashboard/forms': typeof ProtectedDashboardFormsIndexRoute
  '/dashboard/forms/$type/$id/edit': typeof ProtectedDashboardFormsTypeIdEditRoute
  '/dashboard/forms/$type/$id': typeof ProtectedDashboardFormsTypeIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_advisor': typeof AdvisorRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/_chat': typeof ChatRouteWithChildren
  '/_protected': typeof ProtectedRouteWithChildren
  '/consent': typeof ConsentRoute
  '/_app/forgot-password': typeof AppForgotPasswordRoute
  '/_app/form': typeof AppFormRoute
  '/_app/login': typeof AppLoginRoute
  '/_app/pending-approval': typeof AppPendingApprovalRoute
  '/_app/signup': typeof AppSignupRoute
  '/_protected/dashboard': typeof ProtectedDashboardRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/approve/$token': typeof AppApproveTokenRoute
  '/_app/confirm-email-change/$token': typeof AppConfirmEmailChangeTokenRoute
  '/_app/reset-password/$token': typeof AppResetPasswordTokenRoute
  '/_chat/chat/$type': typeof ChatChatTypeRoute
  '/_protected/dashboard/clients': typeof ProtectedDashboardClientsRoute
  '/_protected/dashboard/forms': typeof ProtectedDashboardFormsRouteWithChildren
  '/_protected/dashboard/notifications': typeof ProtectedDashboardNotificationsRoute
  '/_protected/dashboard/pipeline': typeof ProtectedDashboardPipelineRoute
  '/_protected/dashboard/renewals': typeof ProtectedDashboardRenewalsRoute
  '/_protected/dashboard/reports': typeof ProtectedDashboardReportsRoute
  '/_protected/dashboard/settings': typeof ProtectedDashboardSettingsRoute
  '/_protected/dashboard/': typeof ProtectedDashboardIndexRoute
  '/_advisor/a/$username/$type': typeof AdvisorAUsernameTypeRoute
  '/_advisor/a/$username/': typeof AdvisorAUsernameIndexRoute
  '/_protected/dashboard/forms/': typeof ProtectedDashboardFormsIndexRoute
  '/_protected/dashboard/forms/$type/$id': typeof ProtectedDashboardFormsTypeIdRouteWithChildren
  '/_protected/dashboard/forms/$type/$id/edit': typeof ProtectedDashboardFormsTypeIdEditRoute
  '/_protected/dashboard/forms/$type/$id/': typeof ProtectedDashboardFormsTypeIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/consent'
    | '/forgot-password'
    | '/form'
    | '/login'
    | '/pending-approval'
    | '/signup'
    | '/dashboard'
    | '/approve/$token'
    | '/confirm-email-change/$token'
    | '/reset-password/$token'
    | '/chat/$type'
    | '/dashboard/clients'
    | '/dashboard/forms'
    | '/dashboard/notifications'
    | '/dashboard/pipeline'
    | '/dashboard/renewals'
    | '/dashboard/reports'
    | '/dashboard/settings'
    | '/dashboard/'
    | '/a/$username/$type'
    | '/a/$username/'
    | '/dashboard/forms/'
    | '/dashboard/forms/$type/$id'
    | '/dashboard/forms/$type/$id/edit'
    | '/dashboard/forms/$type/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/consent'
    | '/forgot-password'
    | '/form'
    | '/login'
    | '/pending-approval'
    | '/signup'
    | '/approve/$token'
    | '/confirm-email-change/$token'
    | '/reset-password/$token'
    | '/chat/$type'
    | '/dashboard/clients'
    | '/dashboard/notifications'
    | '/dashboard/pipeline'
    | '/dashboard/renewals'
    | '/dashboard/reports'
    | '/dashboard/settings'
    | '/dashboard'
    | '/a/$username/$type'
    | '/a/$username'
    | '/dashboard/forms'
    | '/dashboard/forms/$type/$id/edit'
    | '/dashboard/forms/$type/$id'
  id:
    | '__root__'
    | '/_advisor'
    | '/_app'
    | '/_chat'
    | '/_protected'
    | '/consent'
    | '/_app/forgot-password'
    | '/_app/form'
    | '/_app/login'
    | '/_app/pending-approval'
    | '/_app/signup'
    | '/_protected/dashboard'
    | '/_app/'
    | '/_app/approve/$token'
    | '/_app/confirm-email-change/$token'
    | '/_app/reset-password/$token'
    | '/_chat/chat/$type'
    | '/_protected/dashboard/clients'
    | '/_protected/dashboard/forms'
    | '/_protected/dashboard/notifications'
    | '/_protected/dashboard/pipeline'
    | '/_protected/dashboard/renewals'
    | '/_protected/dashboard/reports'
    | '/_protected/dashboard/settings'
    | '/_protected/dashboard/'
    | '/_advisor/a/$username/$type'
    | '/_advisor/a/$username/'
    | '/_protected/dashboard/forms/'
    | '/_protected/dashboard/forms/$type/$id'
    | '/_protected/dashboard/forms/$type/$id/edit'
    | '/_protected/dashboard/forms/$type/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdvisorRoute: typeof AdvisorRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  ChatRoute: typeof ChatRouteWithChildren
  ProtectedRoute: typeof ProtectedRouteWithChildren
  ConsentRoute: typeof ConsentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/consent': {
      id: '/consent'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof ConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_advisor': {
      id: '/_advisor'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdvisorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_app/signup': {
      id: '/_app/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AppSignupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pending-approval': {
      id: '/_app/pending-approval'
      path: '/pending-approval'
      fullPath: '/pending-approval'
      preLoaderRoute: typeof AppPendingApprovalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/login': {
      id: '/_app/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AppLoginRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/form': {
      id: '/_app/form'
      path: '/form'
      fullPath: '/form'
      preLoaderRoute: typeof AppFormRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forgot-password': {
      id: '/_app/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AppForgotPasswordRouteImport
      parentRoute: typeof AppRoute
    }
    '/_protected/dashboard/': {
      id: '/_protected/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof ProtectedDashboardIndexRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/settings': {
      id: '/_protected/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof ProtectedDashboardSettingsRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/reports': {
      id: '/_protected/dashboard/reports'
      path: '/reports'
      fullPath: '/dashboard/reports'
      preLoaderRoute: typeof ProtectedDashboardReportsRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/renewals': {
      id: '/_protected/dashboard/renewals'
      path: '/renewals'
      fullPath: '/dashboard/renewals'
      preLoaderRoute: typeof ProtectedDashboardRenewalsRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/pipeline': {
      id: '/_protected/dashboard/pipeline'
      path: '/pipeline'
      fullPath: '/dashboard/pipeline'
      preLoaderRoute: typeof ProtectedDashboardPipelineRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/notifications': {
      id: '/_protected/dashboard/notifications'
      path: '/notifications'
      fullPath: '/dashboard/notifications'
      preLoaderRoute: typeof ProtectedDashboardNotificationsRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/forms': {
      id: '/_protected/dashboard/forms'
      path: '/forms'
      fullPath: '/dashboard/forms'
      preLoaderRoute: typeof ProtectedDashboardFormsRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_protected/dashboard/clients': {
      id: '/_protected/dashboard/clients'
      path: '/clients'
      fullPath: '/dashboard/clients'
      preLoaderRoute: typeof ProtectedDashboardClientsRouteImport
      parentRoute: typeof ProtectedDashboardRoute
    }
    '/_chat/chat/$type': {
      id: '/_chat/chat/$type'
      path: '/chat/$type'
      fullPath: '/chat/$type'
      preLoaderRoute: typeof ChatChatTypeRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_app/reset-password/$token': {
      id: '/_app/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof AppResetPasswordTokenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/confirm-email-change/$token': {
      id: '/_app/confirm-email-change/$token'
      path: '/confirm-email-change/$token'
      fullPath: '/confirm-email-change/$token'
      preLoaderRoute: typeof AppConfirmEmailChangeTokenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approve/$token': {
      id: '/_app/approve/$token'
      path: '/approve/$token'
      fullPath: '/approve/$token'
      preLoaderRoute: typeof AppApproveTokenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_protected/dashboard/forms/': {
      id: '/_protected/dashboard/forms/'
      path: '/'
      fullPath: '/dashboard/forms/'
      preLoaderRoute: typeof ProtectedDashboardFormsIndexRouteImport
      parentRoute: typeof ProtectedDashboardFormsRoute
    }
    '/_advisor/a/$username/': {
      id: '/_advisor/a/$username/'
      path: '/a/$username'
      fullPath: '/a/$username/'
      preLoaderRoute: typeof AdvisorAUsernameIndexRouteImport
      parentRoute: typeof AdvisorRoute
    }
    '/_advisor/a/$username/$type': {
      id: '/_advisor/a/$username/$type'
      path: '/a/$username/$type'
      fullPath: '/a/$username/$type'
      preLoaderRoute: typeof AdvisorAUsernameTypeRouteImport
      parentRoute: typeof AdvisorRoute
    }
    '/_protected/dashboard/forms/$type/$id': {
      id: '/_protected/dashboard/forms/$type/$id'
      path: '/$type/$id'
      fullPath: '/dashboard/forms/$type/$id'
      preLoaderRoute: typeof ProtectedDashboardFormsTypeIdRouteImport
      parentRoute: typeof ProtectedDashboardFormsRoute
    }
    '/_protected/dashboard/forms/$type/$id/': {
      id: '/_protected/dashboard/forms/$type/$id/'
      path: '/'
      fullPath: '/dashboard/forms/$type/$id/'
      preLoaderRoute: typeof ProtectedDashboardFormsTypeIdIndexRouteImport
      parentRoute: typeof ProtectedDashboardFormsTypeIdRoute
    }
    '/_protected/dashboard/forms/$type/$id/edit': {
      id: '/_protected/dashboard/forms/$type/$id/edit'
      path: '/edit'
      fullPath: '/dashboard/forms/$type/$id/edit'
      preLoaderRoute: typeof ProtectedDashboardFormsTypeIdEditRouteImport
      parentRoute: typeof ProtectedDashboardFormsTypeIdRoute
    }
  }
}

interface AdvisorRouteChildren {
  AdvisorAUsernameTypeRoute: typeof AdvisorAUsernameTypeRoute
  AdvisorAUsernameIndexRoute: typeof AdvisorAUsernameIndexRoute
}

const AdvisorRouteChildren: AdvisorRouteChildren = {
  AdvisorAUsernameTypeRoute: AdvisorAUsernameTypeRoute,
  AdvisorAUsernameIndexRoute: AdvisorAUsernameIndexRoute,
}

const AdvisorRouteWithChildren =
  AdvisorRoute._addFileChildren(AdvisorRouteChildren)

interface AppRouteChildren {
  AppForgotPasswordRoute: typeof AppForgotPasswordRoute
  AppFormRoute: typeof AppFormRoute
  AppLoginRoute: typeof AppLoginRoute
  AppPendingApprovalRoute: typeof AppPendingApprovalRoute
  AppSignupRoute: typeof AppSignupRoute
  AppIndexRoute: typeof AppIndexRoute
  AppApproveTokenRoute: typeof AppApproveTokenRoute
  AppConfirmEmailChangeTokenRoute: typeof AppConfirmEmailChangeTokenRoute
  AppResetPasswordTokenRoute: typeof AppResetPasswordTokenRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppForgotPasswordRoute: AppForgotPasswordRoute,
  AppFormRoute: AppFormRoute,
  AppLoginRoute: AppLoginRoute,
  AppPendingApprovalRoute: AppPendingApprovalRoute,
  AppSignupRoute: AppSignupRoute,
  AppIndexRoute: AppIndexRoute,
  AppApproveTokenRoute: AppApproveTokenRoute,
  AppConfirmEmailChangeTokenRoute: AppConfirmEmailChangeTokenRoute,
  AppResetPasswordTokenRoute: AppResetPasswordTokenRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface ChatRouteChildren {
  ChatChatTypeRoute: typeof ChatChatTypeRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatChatTypeRoute: ChatChatTypeRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface ProtectedDashboardFormsTypeIdRouteChildren {
  ProtectedDashboardFormsTypeIdEditRoute: typeof ProtectedDashboardFormsTypeIdEditRoute
  ProtectedDashboardFormsTypeIdIndexRoute: typeof ProtectedDashboardFormsTypeIdIndexRoute
}

const ProtectedDashboardFormsTypeIdRouteChildren: ProtectedDashboardFormsTypeIdRouteChildren =
  {
    ProtectedDashboardFormsTypeIdEditRoute:
      ProtectedDashboardFormsTypeIdEditRoute,
    ProtectedDashboardFormsTypeIdIndexRoute:
      ProtectedDashboardFormsTypeIdIndexRoute,
  }

const ProtectedDashboardFormsTypeIdRouteWithChildren =
  ProtectedDashboardFormsTypeIdRoute._addFileChildren(
    ProtectedDashboardFormsTypeIdRouteChildren,
  )

interface ProtectedDashboardFormsRouteChildren {
  ProtectedDashboardFormsIndexRoute: typeof ProtectedDashboardFormsIndexRoute
  ProtectedDashboardFormsTypeIdRoute: typeof ProtectedDashboardFormsTypeIdRouteWithChildren
}

const ProtectedDashboardFormsRouteChildren: ProtectedDashboardFormsRouteChildren =
  {
    ProtectedDashboardFormsIndexRoute: ProtectedDashboardFormsIndexRoute,
    ProtectedDashboardFormsTypeIdRoute:
      ProtectedDashboardFormsTypeIdRouteWithChildren,
  }

const ProtectedDashboardFormsRouteWithChildren =
  ProtectedDashboardFormsRoute._addFileChildren(
    ProtectedDashboardFormsRouteChildren,
  )

interface ProtectedDashboardRouteChildren {
  ProtectedDashboardClientsRoute: typeof ProtectedDashboardClientsRoute
  ProtectedDashboardFormsRoute: typeof ProtectedDashboardFormsRouteWithChildren
  ProtectedDashboardNotificationsRoute: typeof ProtectedDashboardNotificationsRoute
  ProtectedDashboardPipelineRoute: typeof ProtectedDashboardPipelineRoute
  ProtectedDashboardRenewalsRoute: typeof ProtectedDashboardRenewalsRoute
  ProtectedDashboardReportsRoute: typeof ProtectedDashboardReportsRoute
  ProtectedDashboardSettingsRoute: typeof ProtectedDashboardSettingsRoute
  ProtectedDashboardIndexRoute: typeof ProtectedDashboardIndexRoute
}

const ProtectedDashboardRouteChildren: ProtectedDashboardRouteChildren = {
  ProtectedDashboardClientsRoute: ProtectedDashboardClientsRoute,
  ProtectedDashboardFormsRoute: ProtectedDashboardFormsRouteWithChildren,
  ProtectedDashboardNotificationsRoute: ProtectedDashboardNotificationsRoute,
  ProtectedDashboardPipelineRoute: ProtectedDashboardPipelineRoute,
  ProtectedDashboardRenewalsRoute: ProtectedDashboardRenewalsRoute,
  ProtectedDashboardReportsRoute: ProtectedDashboardReportsRoute,
  ProtectedDashboardSettingsRoute: ProtectedDashboardSettingsRoute,
  ProtectedDashboardIndexRoute: ProtectedDashboardIndexRoute,
}

const ProtectedDashboardRouteWithChildren =
  ProtectedDashboardRoute._addFileChildren(ProtectedDashboardRouteChildren)

interface ProtectedRouteChildren {
  ProtectedDashboardRoute: typeof ProtectedDashboardRouteWithChildren
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDashboardRoute: ProtectedDashboardRouteWithChildren,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AdvisorRoute: AdvisorRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  ChatRoute: ChatRouteWithChildren,
  ProtectedRoute: ProtectedRouteWithChildren,
  ConsentRoute: ConsentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
